import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { SideMenuDataCompany } from "./SideMenuDataCompany";
import { SideMenuDataStation } from "./SideMenuDataStation";
import { SideMenuDataAdminLevels } from "./SideMenuDataAdminLevels";
import { RenderSecure } from "../../util/script/RenderSecure";
import functions from "../../util/functions";
const Sidebar = ({ theme }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const activeCompanyId = localStorage.getItem("FuelFy@company_id") || null;
  const activeStationId = localStorage.getItem("FuelFy@station_id") || null;
  const user_role_id = localStorage.getItem("FuelFy@rollly") || null;
  // Determine the menu data
  let SideMenuData = {};
  if (user_role_id == 1 || user_role_id == 2) {
    if (activeStationId) {
      SideMenuData = SideMenuDataStation;
    } else if (activeCompanyId) {
      SideMenuData = SideMenuDataCompany;
    } else {
      SideMenuData = SideMenuDataAdminLevels;
    }
  } else {
    // Non-admin
    if (activeCompanyId && activeStationId) {
      SideMenuData = SideMenuDataStation;
    } else if (activeCompanyId) {
      SideMenuData = SideMenuDataCompany;
    } else if (activeStationId) {
      SideMenuData = SideMenuDataStation;
    }
  }
  const isDark = theme === "dark-theme";
  const linkColor = isDark ? "#cefbf3ff" : "#024144ff";
  const [openMenu, setOpenMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState({
    menuId: null,
    subIndex: null,
  });
  // Auto-open parent menu when current path matches
  useEffect(() => {
    if (!SideMenuData) return;
    Object.entries(SideMenuData).forEach(([id, item]) => {
      if (!item) return;
      if (item.subMenu) {
        item.subMenu.forEach((subItem, index) => {
          if (subItem.link === currentPath) {
            setOpenMenu(parseInt(id));
            setActiveSubMenu({ menuId: parseInt(id), subIndex: index });
          }
        });
      } else if (item.link === currentPath) {
        setOpenMenu(null);
        setActiveSubMenu({ menuId: null, subIndex: null });
      }
    });
  }, [currentPath, SideMenuData]);
  const toggleMenu = (id) => setOpenMenu(openMenu === id ? null : id);
  return (
    <div
      className="main-sidebar main-sidebar-sticky side-menu"
      style={{ height: "100vh", overflowY: "auto", marginBottom: "100px" }}
    >
      {/* Logo */}
      <div className="sidemenu-logo">
        <Link className="main-logo" to="/">
          <img
            src={process.env.PUBLIC_URL + "/assets/img/brand/logo.png"}
            className="header-brand-img desktop-logo"
            alt="logo"
          />
          <img
            src={process.env.PUBLIC_URL + "/assets/img/brand/icon.png"}
            className="header-brand-img icon-logo"
            alt="logo"
          />
          <img
            src={process.env.PUBLIC_URL + "/assets/img/brand/logo-light.png"}
            className="header-brand-img desktop-logo theme-logo"
            alt="logo"
          />
          <img
            src={process.env.PUBLIC_URL + "/assets/img/brand/icon-light.png"}
            className="header-brand-img icon-logo theme-logo"
            alt="logo"
          />
        </Link>
      </div>
      {/* Sidebar Body */}
      <div className="main-sidebar-body">
        <ul className="nav">
          <li className="nav-label">Dashboard</li>
          {Object.entries(SideMenuData || {}).map(([id, item]) => (
            <React.Fragment key={`menu-${id}`}>
              {/* Section label */}
              {item.label && (
                <li
                  className="nav-label"
                  style={{ color: linkColor, opacity: 0.7 }}
                >
                  {item.label}
                </li>
              )}
              {/* Menu with submenu */}
              {!item.label && item.subMenu && (
                <li
                  className={`nav-item ${
                    openMenu === parseInt(id) ? "show" : ""
                  }`}
                >
                  <Link
                    className="nav-link with-sub"
                    to="#"
                    onClick={() => toggleMenu(parseInt(id))}
                    style={{ color: linkColor }}
                  >
                    <i className={item.icon} style={{ color: linkColor }}></i>
                    <span className="sidemenu-label">{item.name}</span>
                    <i
                      className={`angle fe fe-chevron-${
                        openMenu === parseInt(id) ? "down" : "right"
                      }`}
                      style={{ color: linkColor }}
                    />
                  </Link>
                  <ul
                    className="nav-sub"
                    style={{
                      display: openMenu === parseInt(id) ? "block" : "none",
                    }}
                  >
                    {item.subMenu.map((subItem, index) => {
                      const isActive =
                        activeSubMenu.menuId === parseInt(id) &&
                        activeSubMenu.subIndex === index;
                      return (
                        <RenderSecure
                          code={subItem.AccessCode}
                          requireStationId={subItem.requireStationId}
                          key={`secure-${id}-${index}`}
                        >
                          <li className="nav-sub-item">
                            <Link
                              className={`nav-sub-link ${
                                isActive ? "show" : ""
                              }`}
                              to={subItem.link}
                              style={{
                                color: linkColor,
                                fontWeight: isActive ? "bold" : "normal",
                              }}
                            >
                              {subItem.name}
                            </Link>
                          </li>
                        </RenderSecure>
                      );
                    })}
                  </ul>
                </li>
              )}
              {/* Regular menu (no submenu) */}
              {!item.label && !item.subMenu && (
                <RenderSecure
                  code={item.AccessCode}
                  requireStationId={item.requireStationId}
                >
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to={item.link}
                      style={{ color: linkColor }}
                    >
                      <i className={item.icon} style={{ color: linkColor }}></i>
                      <span className="sidemenu-label">{item.name}</span>
                    </Link>
                  </li>
                </RenderSecure>
              )}
            </React.Fragment>
          ))}
        </ul>
      </div>
    </div>
  );
};
export default Sidebar;
